
export interface FormatOptions {
  locale?: string;
  module?: string;
  currency?: string;
  timeZone?: string | null;
  preventNumberDefault?: boolean;
}
